import { render, staticRenderFns } from "./ximalaya-audio-bar.vue?vue&type=template&id=4bea124a&scoped=true&"
import script from "./ximalaya-audio-bar.vue?vue&type=script&lang=js&"
export * from "./ximalaya-audio-bar.vue?vue&type=script&lang=js&"
import style0 from "./ximalaya-audio-bar.vue?vue&type=style&index=0&id=4bea124a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bea124a",
  null
  
)

export default component.exports